export class PageUrlData {
    doc_host: string;
    doc_path: string;

    constructor(path) {
        this.doc_host = window.location.href.substring(0, window.location.href.indexOf('#'));
        this.doc_path = path;
    }
}